import { render, staticRenderFns } from "./DetailHealth.vue?vue&type=template&id=57f99450&scoped=true"
import script from "./DetailHealth.vue?vue&type=script&lang=js"
export * from "./DetailHealth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f99450",
  null
  
)

export default component.exports